import { render, staticRenderFns } from "./svg.vue?vue&type=template&id=4926bab7&scoped=true&"
import script from "./svg.vue?vue&type=script&lang=js&"
export * from "./svg.vue?vue&type=script&lang=js&"
import style0 from "./svg.vue?vue&type=style&index=0&id=4926bab7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4926bab7",
  null
  
)

export default component.exports